import React from 'react';
import { useField } from 'formik';
import { TextFieldProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { TextInput } from '../../../../Inputs';


const useNotesStyles = makeStyles()({
  root: {
    '& .Mui-focused textarea': {
      paddingTop: '17px',
      paddingBottom: '17px',
      paddingLeft: '14px',

      '&::placeholder': {
        color: 'transparent',
      }
    },
    '& .Mui-focused fieldset': {
      opacity: 1,
    },
  },
  squashed: {
    '& fieldset': {
      opacity: 0,
      transition: 'opacity 200ms'
    },
    '& textarea': {
      paddingTop: '4px',
      paddingBottom: '0px',
      paddingLeft: '0px',
      transition: 'padding 200ms',

      '&::placeholder': {
        transition: 'color 100ms',
      }
    },
  },
  full: {
    '& textarea': {
      paddingTop: '17px',
      paddingBottom: '17px',
      paddingLeft: '14px',

      '&::placeholder': {
        color: 'transparent',
      }
    },
    '& fieldset': {
      opacity: 1,
    },
  },
  multiline: {
    padding: '0px',
  }
});


export type NotesInputDesktopProps = {
  name: string;
  variant?: 'desktop';
  color?: TextFieldProps['color'];
};
export const NotesInputDesktop: React.FC<NotesInputDesktopProps> = (props) => {
  const [ field ] = useField<string>(props.name);
  const { classes, cx } = useNotesStyles();
  const l10n = useL10n();

  const className = cx(classes.root, classes.squashed, {
    [classes.full]: !!field.value,
  });

  return (
    <TextInput
      fullWidth
      inputClasses={{ multiline: classes.multiline }}
      className={className}
      name={props.name}
      autoComplete="off"
      placeholder={l10n.schedule.createAppointment.notesToClient}
      multiline
      color={props.color}
    />
  );
};

export type NotesInputMobileProps = {
  name: string;
  variant?: 'mobile';
  color?: TextFieldProps['color'];
};
export const NotesInputMobile: React.FC<NotesInputMobileProps> = (props) => {
  return (
    <TextInput
      label="Notes (optional)"
      fullWidth
      name={props.name}
      autoComplete="off"
      placeholder="Send a message to the client"
      multiline
      color={props.color}
    />
  );
};


export const NotesInput: React.FC<NotesInputDesktopProps | NotesInputMobileProps> = ({ variant, ...props }) => {
  if (variant === 'mobile') {
    return <NotesInputMobile {...props} />;
  }

  return <NotesInputDesktop {...props} />;
};
